export const AUTH_CODES = {
  userExists: 'userExists',
  userNotExists: 'userNotExists'
}
